<ng-template #contentHeaderTemplate></ng-template>

@if (timeTrackingEmployee) {
  <div class="pb-3">
    <div class="card">
      <div class="card-body p-3 pt-2">

        <div class="row">
          <div class="col-4">
            <app-authenticated-time-tracking-overview-month-picker
              [yearControl]="timeframeForm.controls.year"
              [monthControl]="timeframeForm.controls.month"
            ></app-authenticated-time-tracking-overview-month-picker>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-4">
            <div class="rounded shadow-sm p-3">
              <div class="text-body-secondary">{{ 'authenticated.time_tracking.overview.edit.total_work_hours' | translate }}</div>
              <div class="fs-3">{{ timeTrackingOverview?.work_hours ?? 0 | number }}h</div>
            </div>
          </div>

          <div class="col-4">
            <div class="rounded shadow-sm p-3">
              <div class="text-body-secondary">{{ 'authenticated.time_tracking.overview.edit.current_month_overtime' | translate }}</div>
              <div
                [class.positive-overtime]="(timeTrackingOverview?.overtime_hours ?? 0) > 0"
                [class.negative-overtime]="(timeTrackingOverview?.overtime_hours ?? 0) < 0"
                class="fs-3">{{ timeTrackingOverview?.overtime_hours ?? 0 | number }}h</div>
            </div>
          </div>

          <div class="col-4">
            <div class="rounded shadow-sm p-3">
              <div class="text-body-secondary">{{ 'authenticated.time_tracking.overview.edit.accumulated_overtime' | translate }}</div>
              <div
                [class.positive-overtime]="(timeTrackingOverview?.accumulated_overtime_hours ?? 0) > 0"
                [class.negative-overtime]="(timeTrackingOverview?.accumulated_overtime_hours ?? 0) < 0"
                class="fs-3">{{ timeTrackingOverview?.accumulated_overtime_hours ?? 0 | number }}h</div>
            </div>
          </div>
        </div>

        <div class="mt-5">
          <div class="grid header">
            <div></div>
            <div>{{ 'authenticated.time_tracking.overview.edit.headings.date' | translate }}</div>
            <div>{{ 'authenticated.time_tracking.overview.edit.headings.type' | translate }}</div>
            <div>{{ 'authenticated.time_tracking.overview.edit.headings.start_at' | translate }}</div>
            <div>{{ 'authenticated.time_tracking.overview.edit.headings.end_at' | translate }}</div>
            <div>{{ 'authenticated.time_tracking.overview.edit.headings.break_time' | translate }}</div>
            <div>{{ 'authenticated.time_tracking.overview.edit.headings.hours' | translate }}</div>
            <div>{{ 'authenticated.time_tracking.overview.edit.headings.overtime' | translate }}</div>
            <div>{{ 'authenticated.time_tracking.overview.edit.headings.comment' | translate }}</div>
            <div></div>
          </div>

          @for (row of rows; track row.day) {
            <app-authenticated-time-tracking-overview-edit-date-row
              [date]="row.day"
              [entry]="row.entry"
              [holiday]="row.holiday"
              [canBeEdited]="row.canBeEdited"
              [shouldWork]="row.shouldWork"
              (entryChanged)="loadData()"
              (entryDeleted)="loadData()"
            ></app-authenticated-time-tracking-overview-edit-date-row>
          }

          <div class="grid footer">
            <div>{{ 'authenticated.time_tracking.overview.edit.total' | translate }}</div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div>{{ (timeTrackingOverview?.work_hours ?? 0) | formatDuration: 'hours' }}</div>

            <div
              [class.positive-overtime]="(timeTrackingOverview?.overtime_hours ?? 0) > 0"
              [class.negative-overtime]="(timeTrackingOverview?.overtime_hours ?? 0) < 0"
            >{{ (timeTrackingOverview?.overtime_hours ?? 0) | formatDuration: 'hours' }}</div>

            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
